import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import V2SEO from '../components/V2SEO';
import { blogPosts, categories } from '../../blogData';

const Blog = () => {
  const [category, setCategory] = useState('All');
  const posts = blogPosts.filter((p) => category === 'All' || p.category === category);

  return (
    <>
      <V2SEO
        title="Drone Blog — FPV, FAA Rules & Aerial Tips from a Working PA Pilot"
        description="Field notes from a working FAA Part 107 drone pilot in the Lehigh Valley: FPV builds, Part 107 licensing, Pennsylvania drone regulations, and choosing the right drone for the job."
        path="/blog"
        keywords="drone blog, FPV drone blog, Part 107 guide, Pennsylvania drone laws, drone tips Lehigh Valley"
      />

      <section className="v2-svc-hero">
        <div className="v2-container">
          <span className="v2-eyebrow">Blog</span>
          <h1>Drone Industry Insights & Guides</h1>
          <p className="v2-prose" style={{ marginTop: '1rem' }}>
            Articles on FPV technology, FAA regulations, and professional drone operations,
            written by FAA-certified pilot Josh Kolonia.
          </p>
        </div>
      </section>

      <section className="v2-section v2-section--tight">
        <div className="v2-container">
          <div className="v2-filter">
            {categories.map((c) => (
              <button
                key={c}
                className={category === c ? 'is-active' : ''}
                onClick={() => setCategory(c)}
              >
                {c}
              </button>
            ))}
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: '1.2rem',
          }}>
            {posts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                style={{
                  border: '1px solid var(--v2-line)',
                  borderRadius: '22px',
                  overflow: 'hidden',
                  background: 'rgba(255,255,255,0.02)',
                  textDecoration: 'none',
                  color: 'inherit',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div style={{ aspectRatio: '16 / 9', overflow: 'hidden', background: 'var(--v2-bg-card)' }}>
                  <img
                    src={post.image}
                    alt={post.title}
                    loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', flexGrow: 1 }}>
                  <span className="v2-eyebrow">{post.category} · {post.date}</span>
                  <h2 style={{ margin: 0, fontSize: '1.25rem', lineHeight: 1.3 }}>{post.title}</h2>
                  <p style={{ margin: 0, color: 'var(--v2-text-dim)', fontSize: '0.95rem', lineHeight: 1.6 }}>
                    {post.excerpt.length > 150 ? `${post.excerpt.slice(0, 147)}…` : post.excerpt}
                  </p>
                  <span className="v2-service__cta" style={{ marginTop: 'auto' }}>Read Article</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="v2-section v2-section--tight">
        <div className="v2-container">
          <div className="v2-cta">
            <h2>Have a project that needs a professional drone pilot?</h2>
            <p>Tell us what you're planning and we'll respond with a recommended approach and quote.</p>
            <Link to="/contact" className="v2-btn v2-btn--primary">Request a Quote</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
